import SimilarListings from './SimilarListings.component';

export default SimilarListings;
